import * as React from 'react';
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import {useTranslation} from "react-i18next";
import {LoadingItem} from "../loading-item/LoadingItem";
import {Alert, CircularProgress} from "@mui/material";
import ExpenseDto from "../../dto/ExpenseDto";
import {useDeleteExpenseMutation} from "../../store/apis/expenseApi";

interface Props {
    row: ExpenseDto
}

export default function ExpenseDelete(props: Props) {
    const {t} = useTranslation();
    const {row} = props;
    const [deleteExpense, {isLoading, error}] = useDeleteExpenseMutation();

    const getMessage = () => {
        return `${t('Are you sure delete expense')}:\n${t('Note')}: ${row?.note}\n
        ${t('FileName')}: ${row?.fileName} zł.\n${t('Created at')}: ${row?.createdAt}\n?`;
    }

    const deleteById = async (businessKey: string) => {
        if (confirm(getMessage())) {
            await deleteExpense(businessKey);
        }
    }

    if (isLoading) {
        return <LoadingItem><CircularProgress/></LoadingItem>;
    }

    if (error) {
        return <Alert severity="error">{t("Cannot delete expense!")}</Alert>;
    }

    return (
        <IconButton onClick={() => deleteById(row.id)} disabled={isLoading}>
            <DeleteIcon/>
        </IconButton>
    );
};